import type { Point, CategorieMarqueur, Projet } from '../../types/map';

export type { Point, CategorieMarqueur, Projet };

/**
 * Nombre minimal de caractères pour déclencher le filtre textuel (SPEC §3.6).
 * Constante CONFIGURABLE : en dessous de ce seuil, la recherche n'applique
 * aucun filtre sur les mots-clés.
 */
export const MIN_SEARCH_CHARS = 2;

export interface FilterOptions {
  /** UUID du fond de carte (campus) sélectionné — `baseMaps[].id` (SPEC §2.7). */
  baseMapId?: string;
  /** Identifiants des catégories cochées. */
  checkedCategorieIds: Set<number>;
  /** Mots-clés saisis ; ignorés si `trim().length < MIN_SEARCH_CHARS`. */
  keywords: string;
}
